import useSWR from 'swr';
import { useMemo } from 'react';

import { httpGet, httpPost, httpPostRead } from 'src/utils/cms-axios';

export function getPkg(data) {

  const { site_id, code } = data

  return httpGet("/template/pkg", {
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getTemplatePkgList(data) {

  const { site_id } = data

  return httpGet("/template/pkg/list", {}, {
    "cms-site-id": site_id,
  });
}

export function getTemplate(data) {

  const { site_id, tpl_code, template_pkg_code } = data

  return httpGet("/template", {
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getTemplateList(data) {

  const { site_id, template_pkg_code, limit, offset } = data

  // 副作用のない一覧取得。間欠 500 に備えて再試行させる（httpPostRead）
  return httpPostRead("/template/list", {
    "template_pkg_code": template_pkg_code,
    "limit": limit,
    "offset": offset,
  }, {
    "cms-site-id": site_id,
  });
}

export function getTemplateLayout(data) {

  const { site_id, tpl_code, template_pkg_code } = data

  return httpGet("/template/layout", {
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getTemplateLayoutList(data) {

  const { site_id, template_pkg_code, limit, offset } = data

  // 副作用のない一覧取得。間欠 500 に備えて再試行させる（httpPostRead）
  return httpPostRead("/template/layout/list", {
    "template_pkg_code": template_pkg_code,
    "limit": limit,
    "offset": offset,
  }, {
    "cms-site-id": site_id,
  });
}

export function getBlock(data) {

  const { site_id, tpl_code, template_pkg_code } = data

  return httpGet("/template/block", {
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function getBlockList(data) {

  const { site_id, template_pkg_code, limit, offset } = data

  // 副作用のない一覧取得。間欠 500 に備えて再試行させる（httpPostRead）
  return httpPostRead("/template/block/list", {
    "template_pkg_code": template_pkg_code,
    "limit": limit,
    "offset": offset,
  }, {
    "cms-site-id": site_id,
  });
}

export function createPkg(data) {

  const { site_id, name, code } = data

  return httpPost("/template/pkg/create", {
    "name": name,
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function updatePkg(data) {

  const { site_id, name, code } = data

  return httpPost("/template/pkg/update", {
    "name": name,
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function deletePkg(data) {

  const { site_id, code } = data

  return httpPost("/template/pkg/delete", {
    "code": code,
  }, {
    "cms-site-id": site_id,
  });
}

export function createTemplate(data) {

  const { site_id, template_name, tpl_code, template_pkg_code, layout_code, source_code } = data

  return httpPost("/template/create", {
    "template_name": template_name,
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
    "layout_code": layout_code,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function updateTemplate(data) {

  const { site_id, template_name, template_pkg_code, tpl_code, layout_code, source_code } = data

  return httpPost("/template/update", {
    "template_name": template_name,
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
    "layout_code": layout_code,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function deleteTemplate(data) {

  const { site_id, template_pkg_code, tpl_code } = data

  return httpPost("/template/delete", {
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function createLayout(data) {

  const { site_id, template_name, tpl_code, template_pkg_code, source_code } = data

  return httpPost("/template/layout/create", {
    "template_name": template_name,
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function updateLayout(data) {

  const { site_id, template_name, template_pkg_code, tpl_code, source_code } = data

  return httpPost("/template/layout/update", {
    "template_name": template_name,
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function deleteLayout(data) {

  const { site_id, template_pkg_code, tpl_code } = data

  return httpPost("/template/layout/delete", {
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function createBlock(data) {

  const { site_id, template_name, tpl_code, template_pkg_code, layout_codes, source_code } = data

  return httpPost("/template/block/create", {
    "template_name": template_name,
    "tpl_code": tpl_code,
    "template_pkg_code": template_pkg_code,
    "layout_codes": layout_codes,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function updateBlock(data) {

  const { site_id, template_name, template_pkg_code, tpl_code, layout_codes, source_code } = data

  return httpPost("/template/block/update", {
    "template_name": template_name,
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
    "layout_codes": layout_codes,
    "source_code": source_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function deleteBlock(data) {

  const { site_id, template_pkg_code, tpl_code } = data

  return httpPost("/template/block/delete", {
    "template_pkg_code": template_pkg_code,
    "tpl_code": tpl_code,
  }, {
    "cms-site-id": site_id,
  });
}

export function useGetTemplates(site_id, datas) {
  const { template_pkg_code, limit, offset } = datas || {};

  const shouldFetch = Boolean(site_id && template_pkg_code);

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    shouldFetch ? { site_id, template_pkg_code, limit, offset, type: 'templates' } : null,
    () => getTemplateList({ site_id, template_pkg_code, limit, offset })
  );

  const memoizedValue = useMemo(
    () => ({
      templates: data?.template_list || [],
      templatesCount: data?.count || 0,
      templatesLoading: isLoading,
      templatesError: error,
      templatesValidating: isValidating,
      templatesEmpty: !isLoading && !data?.count,
      templatesRefresh: mutate,
    }),
    [mutate, data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetLayouts(site_id, datas) {
  const { template_pkg_code, limit, offset } = datas || {};

  const shouldFetch = Boolean(site_id && template_pkg_code);

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    shouldFetch ? { site_id, template_pkg_code, limit, offset, type: 'layouts' } : null,
    () => getTemplateLayoutList({ site_id, template_pkg_code, limit, offset })
  );

  const memoizedValue = useMemo(
    () => {
      const filteredLayouts = data?.template_list || [];
      return {
        layouts: filteredLayouts,
        layoutsCount: filteredLayouts.length,
        layoutsLoading: isLoading,
        layoutsError: error,
        layoutsValidating: isValidating,
        layoutsEmpty: !isLoading && filteredLayouts.length === 0,
        layoutsRefresh: mutate,
      };
    },
    [mutate, data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetBlocks(site_id, datas) {
  const { template_pkg_code, limit, offset } = datas || {};

  const shouldFetch = Boolean(site_id && template_pkg_code);

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    shouldFetch ? { site_id, template_pkg_code, limit, offset, type: 'blocks' } : null,
    () => getBlockList({ site_id, template_pkg_code, limit, offset })
  );

  const memoizedValue = useMemo(
    () => ({
      blocks: data?.template_list || [],
      blocksCount: data?.count || 0,
      blocksLoading: isLoading,
      blocksError: error,
      blocksValidating: isValidating,
      blocksEmpty: !isLoading && !data?.count,
      blocksRefresh: mutate,
    }),
    [mutate, data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetTemplatePkgList(site_id) {

  const shouldFetch = Boolean(site_id);

  const { data, isLoading, error, isValidating, mutate } = useSWR(
    shouldFetch ? { site_id, type: 'template_pkg_list' } : null,
    () => getTemplatePkgList({ site_id })
  )

  const memoizedValue = useMemo(
    () => ({
      tplPkgList: data || null,
      tplPkgLoading: isLoading || !shouldFetch,
      tplPkgError: error,
      tplPkgValidating: isValidating,
      tplPkgRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate, shouldFetch]
  );

  return memoizedValue
}

export function useGetTemplatePkg(site_id, code) {

  const { data, isLoading, error, isValidating, mutate } = useSWR(site_id && code ? { site_id, code } : null, getPkg)

  const memoizedValue = useMemo(
    () => ({
      tplPkg: data || null,
      tplPkgLoading: isLoading,
      tplPkgError: error,
      tplPkgValidating: isValidating,
      tplPkgRefresh: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue
}
